module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"error_title":"Error","missing_configuration":"Missing Configuration"},"fr":{"error_title":"Error","missing_configuration":"Missing Configuration"}}')
  delete Component.options._Ctor
}
